/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Content_DescriptionInputs */

const en_directory_taxonomy_use_cases_content_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find products for writing, publishing, and content production.`)
};

const zh_directory_taxonomy_use_cases_content_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查找适用于写作、发布和内容生产的产品。`)
};

/**
* | output |
* | --- |
* | "Find products for writing, publishing, and content production." |
*
* @param {Directory_Taxonomy_Use_Cases_Content_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_content_description = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Content_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Content_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_content_description(inputs)
	return zh_directory_taxonomy_use_cases_content_description(inputs)
});
export { directory_taxonomy_use_cases_content_description as "directory.taxonomy.use-cases.content.description" }